import { Assert } from '@team/assert';

export function compareValues(value: unknown, actual: unknown): boolean {
  if (value === actual) {
    return true;
  }

  if (Assert.isNull(value) || Assert.isNull(actual)) {
    return false;
  }

  if (Assert.isObject(value) && Assert.isObject(actual)) {
    const valueKeys = Object.keys(value);
    const actualKeys = Object.keys(actual);

    if (!Assert.isEquals(valueKeys.length, actualKeys.length)) {
      return false;
    }

    for (const key of valueKeys) {
      if (
        !actualKeys.includes(key) ||
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        !compareValues(value[key], actual[key])
      ) {
        return false;
      }
    }

    return true;
  }

  return false;
}
